export default () => ({
  status,
  theme: {
    title: "",
    toolbarDark: false,
  },
});
